import React from 'react';
import { events } from '../data/events/events';

const WebinarBanner = () => {
  const now = new Date();

  const nextEvent = events
    .filter((e) => e.status === 'upcoming' && new Date(e.startDate) >= now)
    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))[0];

  if (!nextEvent) return null;

  return (
    <a
      href={`/events/${nextEvent.slug}`}
      style={{
        display: 'block',
        textAlign: 'center',
        padding: '12px 24px',
        background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
        color: '#fff',
        textDecoration: 'none',
        fontSize: '15px',
        fontWeight: 500,
        lineHeight: 1.4,
      }}
    >
      Upcoming webinar: {nextEvent.title} - {nextEvent.displayDateRange}.&nbsp;
      <span style={{ textDecoration: 'underline', fontWeight: 600 }}>Learn more →</span>
    </a>
  );
};

export default WebinarBanner;
